import React from 'react';
export function Footer() {
  return <footer className="bg-ink text-cream/50 py-12 px-4 text-xs font-sans" data-id="element-179">
      <div className="max-w-5xl mx-auto" data-id="element-180">
        <div className="flex flex-wrap justify-center gap-6 md:gap-8 mb-10" data-id="element-181">
          <a href="#" className="hover:text-cream transition-colors" data-id="element-182">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-cream transition-colors" data-id="element-183">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-cream transition-colors" data-id="element-184">
            Aviso Legal
          </a>
          <a href="#" className="hover:text-cream transition-colors" data-id="element-185">
            Contacto
          </a>
        </div>

        <div className="border-t border-white/10 pt-8 text-center max-w-3xl mx-auto leading-relaxed" data-id="element-186">
          <p className="mb-6 font-bold text-cream/60" data-id="element-187">
            Este producto tiene fines educativos y de acompañamiento personal.
            No sustituye asesoramiento médico, psicológico o profesional. Los
            resultados pueden variar según cada persona y su aplicación
            individual.
          </p>
          <p data-id="element-188">
            © {new Date().getFullYear()} El Código del Cierre™. Todos los
            derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}